export default "__VITE_ASSET__$q6sPXNp__"